export default "__VITE_ASSET__DL2X1zMq__"